import * as types from "./types";
import INITIAL_STATE from "./init";

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.SET_QUESTIONNAIRE: {
      return { ...state, questionnaireId: action.payload };
    }
    case types.SET_SURVEY_STATUS: {
      return { ...state, status: action.payload };
    }
    case types.SET_START_TIME: {
      return { ...state, startTime: action.payload };
    }
    case types.SET_SURVEY_MESSAGE:
      return { ...state, message: action.payload };
    case types.SET_INVITE_ID: {
      return { ...state, inviteId: action.payload };
    }
    case types.SET_PREVENT_ID: {
      return { ...state, preventInviteId: action.payload };
    }
    case types.SET_FOR_GO: {
      return { ...state, forGo: action.payload };
    }
    case types.SET_FEEDBACK_GROUP:
      return { ...state, feedback_group: action.payload };
    case types.SET_SURVEY_SCORE: {
      return { ...state, score: action.payload };
    }
    case types.STORE_ITEMS: {
      return { ...state, items: action.payload };
    }
    case types.HIDE_ITEM_LIST: {
      return { ...state, showItemsList: false };
    }
    case types.SET_LINKED_OPTION_FOR_ITEM: {
      return {
        ...state,
        showItemsList: true,
        linkedOptionForItem: action.payload,
      };
    }
    case types.REMOVE_LINKED_OPTION:
      return { ...state, linkedOptionForItem: null };
    case types.SET_PREVIOUS_RESPONSE: {
      return { ...state, previousResponse: action.payload };
    }
    case types.SET_QUIZ_FLAG: {
      return { ...state, isQuiz: true };
    }
    case types.SET_QUIZ_SCORE: {
      const { quizTotal, quizScore } = action.payload;
      return { ...state, quizTotal, quizScore };
    }
    case types.SET_DIVISION_INFO: {
      return { ...state, divisionInfo: action.payload };
    }
    case types.SET_IS_DEMO: {
      return { ...state, isDemo: action.payload };
    }
    case types.SET_IS_APP_EMBED: {
      return { ...state, isAppEmbed: action.payload };
    }
    case types.SET_AUTO_START: {
      return { ...state, autoStart: action.payload };
    }
    case types.SET_STAGE_NUMBER: {
      return { ...state, stage: action.payload };
    }
    case types.SET_LAST_FEEDBACK_ID: {
      return { ...state, lastFeedbackId: action.payload };
    }
    case types.SET_PREVIOUS_STAGES_RESPONSE: {
      return { ...state, previousStagesResponse: action.payload };
    }
    case types.SET_SURVEY_FIELDS: {
      return { ...state, ...action.payload };
    }
    case types.SET_SUBMITTED_BY: {
      return { ...state, submittedBy: action.payload };
    }
    default:
      return state;
  }
};
